import { formatTime } from '@/helpers/formatTime';
import { RefObject } from 'react';
import { create } from 'zustand';

interface VideoState {
  videoRef: RefObject<HTMLVideoElement> | null;
  setVideoRef: (ref: RefObject<HTMLVideoElement>) => void;
  setVideoCurrentTime: (time: number) => void;
  setProgressCurrentTime: (time: number) => void;
  progressRef: RefObject<HTMLInputElement> | null;
  setProgressRef: (ref: RefObject<HTMLInputElement>) => void;
  currentTime: string;
  setCurrentTime: (time: string) => void;
  remainingTime: string;
  setRemainingTime: (time: string) => void;
  setProgressTime: () => void;
}

export const useVideoStore = create<VideoState>((set) => ({
  videoRef: null,
  setVideoRef: (ref) => set({ videoRef: ref }),
  setVideoCurrentTime: (time) =>
    set((state) => {
      if (state.videoRef?.current) {
        state.videoRef.current.currentTime = time;
      }
      return {};
    }),
  progressRef: null,
  setProgressRef: (ref) => set({ progressRef: ref }),
  setProgressCurrentTime: (time) =>
    set((state) => {
      if (state.progressRef?.current) {
        state.progressRef.current.value = time.toString();
      }
      return {};
    }),
  currentTime: '00:00',
  setCurrentTime: (time) => set({ currentTime: time }),
  remainingTime: '-00:00',
  setRemainingTime: (time) => set({ remainingTime: time }),
  setProgressTime: () =>
    set((state) => {
      if (state.progressRef?.current && state.videoRef?.current?.duration) {
        const currentVideoTime = state.videoRef.current.currentTime;
        const timeLeft = state.videoRef.current.duration - currentVideoTime;
        state.setCurrentTime(formatTime(currentVideoTime));
        state.setRemainingTime(`-${formatTime(timeLeft)}`);
      }
      return {};
    }),
}));

export default useVideoStore;
